<div [formGroup]="form"
  style="display: grid"
     [ngClass]="{
        'in-order-filter': extendedMode,
        'additions-border': extendedMode && (selectedAdditions && selectedAdditions.length)
     }">
  <div [ngClass]="{ 'fields-select': extendedMode }">
    <app-select (valueChange)="writeInStorage($event)"
      [(ngModel)]="selectedAdditions"
      [ngModelOptions]="{ standalone: true }"
      [compareWith]="compareByName"
      style="grid-column-start: 2"
      multiple>
      <app-select-label>{{ 'ORDERS.COMMON.ADDITIONS.search_by_placeholder' | translate }}</app-select-label>
      @for (field of additionalFields; track field) {
        <mat-option [value]="field">{{ field | label:'additional-fields' | async }}</mat-option>
      }
    </app-select>
  </div>

  @for (item of selectedAdditions; track item) {
    <app-separator-input [formControlName]="item.name">
      <app-separator-label>{{ item | label:'additional-fields' | async }}</app-separator-label>
    </app-separator-input>
  }
</div>
